const blynkToken = {
    0: "ih9WueVjBqXegKg2efGtVqUVdFRQdhJa",
    1: "R77dMWPsQ8B7xavEV_HVjaVF01DklJji",
    2: "2rMrMcPwTZnpOnCO9VTSn3pRHrnSMNrF"
  };
  
  module.exports = blynkToken;